export default __webpack_public_path__ + "static/media/section-heading-wheel.b458c1fa.svg";